<template>
  <div>
    <MemberLayout>
      <div class="container">
        <div v-if="!loaded" class="my-5 text-center">
          <h3><i class="fas fa-spinner fa-spin"></i> 載入中請稍候</h3>
        </div>
        <div v-if="loaded" class="row">
          <div class="col-12">
            <div class="card mb-3">
              <div class="card-header text-white bg-primary">帳號設定</div>
              <div class="card-body">
                <div class="form-group">
                  <label for="">會員編號</label>
                  <input
                    id=""
                    type="text"
                    class="form-control"
                    v-model="JPNSEQ"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="">會員姓名</label>
                  <input
                    id=""
                    type="text"
                    class="form-control"
                    v-model="user.name"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="">會員資格</label>
                  <input
                    id=""
                    type="text"
                    class="form-control"
                    v-model="user.qualificationType"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="">會員電話</label>
                  <input
                    id=""
                    type="text"
                    class="form-control"
                    v-model="user.phs"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="card mb-3">
              <div class="card-header text-white bg-primary">通訊地址</div>
              <div class="card-body">
                <div class="form-group">
                  <label for="">縣市區</label>
                  <input
                    id=""
                    type="text"
                    class="form-control"
                    v-model="address.ADDRESS1"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="">地址</label>
                  <input
                    id=""
                    type="text"
                    class="form-control"
                    v-model="address.ADDRESS2"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="card mb-3">
              <div class="card-header text-white bg-primary">密碼管理</div>
              <form @submit.prevent="setNewPassword" class="card-body">
                <div class="form-group">
                  <label for="">原始密碼</label>
                  <input
                    id=""
                    v-model="oldPassword"
                    type="password"
                    class="form-control"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="">新密碼</label>
                  <input
                    id=""
                    v-model="newPassword"
                    type="password"
                    class="form-control"
                    minlength="8"
                    required
                  />
                </div>
                <div class="form-group">
                  <button class="btn btn-primary btn-block">設定新密碼</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </MemberLayout>
  </div>
</template>
<script>
import firebase from "../../api/firebase";
import MemberLayout from "../../components/member/MemberLayout";
import {
  getCurrentUser,
  getCurrentJPNSEQ,
  getCurrentUserDefaultAddress,
} from "../../api/fordaysHelpers";
export default {
  name: "AccountSettingsScreen",
  components: {
    MemberLayout,
  },
  data() {
    return {
      loaded: false,
      oldPassword: "",
      newPassword: "",
      JPNSEQ: "",
      user: {
        SEQ: "",
        JPNSEQ: "",
        name: "",
        email: "",
        phs: "",
        qualificationType: "",
        dispatch: "",
        docSend: "",
      },
      address: {
        ADDRESS1: "",
        ADDRESS2: "",
        CODE: "",
        NAME: "",
        STATUS: 1,
        TEL: "",
        ZIP: "",
      },
    };
  },
  methods: {
    setNewPassword() {
      const vm = this;
      const { oldPassword, newPassword } = vm;
      const user = firebase.auth().currentUser;
      // FIXME:
      const cred = firebase.auth.EmailAuthProvider.credential(
        user.email,
        oldPassword
      );
      user
        .reauthenticateWithCredential(cred)
        .then(() => {
          user
            .updatePassword(newPassword)
            .then(() => {
              // Update successful.
              vm.$swal({
                title: "新密碼設定成功",
                text: "請於下次登入時使用新密碼登入",
                icon: "success",
              });
            })
            .catch((err) => {
              console.log(err);
              // An error happened.
              vm.$swal({
                title: "發生錯誤",
                text: "請重新嘗試",
                icon: "error",
              });
            });
        })
        .catch((err) => {
          console.log(err);
          // An error happened.
          vm.$swal({
            title: "發生錯誤",
            text: "請重新嘗試",
            icon: "error",
          });
        });
    },
  },
  mounted() {
    const vm = this;
    async function fetchData() {
      const JPNSEQ = getCurrentJPNSEQ();
      const user = await getCurrentUser(JPNSEQ);
      const address = await getCurrentUserDefaultAddress(user);
      vm.JPNSEQ = JPNSEQ;
      vm.user = user;
      vm.address = address;
      vm.loaded = true;
    }
    fetchData();
  },
};
</script>